import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import VisualNew from './VisualNew';
import SelecTableros from './SelecTablero';
import Visuales from './Visuales';
import Icons from '../../Containers/Icons';

class AddCards extends Component {
  constructor(){
    super();
    this.imgInput= React.createRef();

    this.state = {
      tab: "",
      vis: "",
      img: "",
      note: "",
      priority: "",
      tabKey: "",
      tabSelected: "",
      visSelected: "",
      showVis: false,
      page2: "closed",
      loading: "",
    }
  }
  componentWillMount(){
    this.props.readVis("visuals");
  }
  saveCard = () => {
    let body = {
      type: "create",
      screen: "card",
      post: {
        tabID: this.state.tab,
        visID: this.state.vis,
        img: this.state.img,
        priority: this.state.priority,
        note: this.state.note
      },
      tkn: this.props.tkn
    }
    body = JSON.stringify(body);
    fetch(`${this.props.url}api.php`, {
      method: "POST",
      headers: {'Content-type': 'application/json'},
      body: body
    }).then((res) => {
      this.props.reload();
    })
  }
  setPriority = (priorities) => {
    this.setState({priority: priorities});
  }
  setNote = (notes) => {
    this.setState({note: notes.target.value});
  }
  selectVisual = (vis) => (event) => {
    let selected = vis.find((element) => element.id === event.target.value);
    this.setState({vis: event.target.value, visSelected: selected});
  }
  selectTab = (tab) => (e) => {
    const tabsel = () => {
      let selected = tab.map((element, key) => {
          return element[0]
      })
      selected = selected.find((element) => {
          return element.id === e.target.value
      });
      return selected
    }
    let selection = tabsel();
    this.setState({tab: e.target.value, tabSelected: selection, showVis: JSON.parse(selection.visuales)});
  }
  nextScreen = () => {
    this.imgInput.current.click();
    this.setState({loading: "open"})
  }
  selectImage = (event) => {
    let img = event.target.files[0];
    let imgName = this.state.tab + "-" + this.state.vis + "-";
    const imgData = new FormData();
    imgData.append("imgToCompress", img);
    imgData.append("tkn", this.props.tkn);
    imgData.append("screen", "addImg");
    imgData.append("imgName", imgName);
    fetch(`${this.props.url}api.php`, {
      method: "POST",
      body: imgData
    }).then((res) => (res.json()).then((res) => {
      this.setState({img: res, page2: "open", loading: ""})
    }));
  }

  render() {
    let {tab, vis, url} = this.props;
    return (
      <div id="addForm">
        <form>
          <div id="addCards2" className={this.state.page2}>
            <VisualNew 
              tab={this.state.tabSelected}
              vis={this.state.visSelected}
              img={this.state.img}
              url={url}
              setPriority={this.setPriority}
              setNote={this.setNote}
              locale={this.props.locale}
              date={this.props.date}
              saveCard={this.saveCard}
            />
          </div>
          <div id="addCards1">
            <NavLink 
              className="Icon backbtn arrow"
              to="/home/tableros">
              <Icons name="arrowThin"/>
            </NavLink>
            <h2>Para añadir una imágen</h2>
            <h1>Elige el tablero y la categoría</h1>
            <h3>Tablero</h3>
              <SelecTableros tab={tab} selectTab={this.selectTab} />
            <h3>Categoría</h3>
            <div id="AddCardsCat">
            {(vis !== undefined) && (vis !== false)
              ? <Visuales 
                vis={vis} 
                selectVis={this.selectVisual} 
                selected={this.state.visSelected}
                approved={this.state.showVis}/>
              : <p>Cargando...</p>
              }
            </div>
            <input ref={this.imgInput} type="file" accept="image/*" capture="camera" onChange={this.selectImage}/>
            <div className="nextBtn" onClick={this.nextScreen}>Siguiente</div>
          </div>
        </form>
        <div id="loadingImg" className={this.state.loading}>Cargando Imagen</div>
      </div>
    )
  }
}

export default AddCards;


// WEBPACK FOOTER //
// ./src/Components/AddCards/AddCards.js